// extracted by mini-css-extract-plugin
export default {"ReportConstructor":"report-constructor_ReportConstructor__owFHV"};